import { IMaintenance } from '@pia/pia.shared';
import { Injectable } from '@angular/core';
import { MaintenanceWorkItem } from 'src/app/business/maintenance/maintenance-work-item';
import { IWorkItem } from 'src/app/common/contracts/work-item/work-item_T';

import { Command } from '../command';
import { EntityCommandHandler } from '../entity-command-handler';

@Injectable()
export class MaintenanceCommandHandler extends EntityCommandHandler<IMaintenance> {
  protected workItem: IWorkItem<IMaintenance>;

  constructor(maintenanceWorkItem: MaintenanceWorkItem) {
    super();
    this.workItem = maintenanceWorkItem;
  }

  canHandle(command: Command): boolean {
    return command.dtoName === 'MaintenanceDto';
  }
}
